import gql from 'graphql-tag';

export const verifyOtpMutation = gql`
  mutation verifyOTP(
    $emailPhoneOrHandle: String!
    $otp: String!
    $newPassword: String
  ) {
    verifyOTP(
      emailPhoneOrHandle: $emailPhoneOrHandle
      otp: $otp
      newPassword: $newPassword
    )
  }
`;
